<template>
  <div>
    <product-top-bar />
    <div class="page-margins">
      <div class="page-title">
        {{ $t('privacy_policy') }}
      </div>

      <div v-if="$i18n.locale == 'en'">
        <ol>
          <li>
            <b>IDENTIFYING DATA:</b> In compliance with the duty of information contained in Article 10 of Law 34/2002, of July 11, Services of the Information Society and Electronic Commerce, the following information is shown below: titular company of <a href="https://www.kaleidologistics.com">www.kaleidologistics.com</a> is <b>KALEIDO LOGISTICS S.L.</b> with CIF B-27.716.422 and domicile for these purposes in Calle Pontevedra 4, 3ª Planta, 36.201, Vigo (Pontevedra) with contact e-mail: <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a>
          </li>
        </ol>
        <ol start="2">
          <li>
            <b>USERS:</b> Access and / or use of this portal of <b>KALEIDO LOGISTICS S.L.</b> attributes the condition of USER, that accepts, from said access and / or use, the General Conditions of use reflected here. The aforementioned conditions will apply regardless of the General Conditions of Contract that in their case are mandatory.
          </li>
          <li>
            <b>USE OF THE PORTAL:</b> <a href="https://www.kaleidologistics.com">www.kaleidologistics.com</a> provides access to a multitude of information, services, programs or data (hereinafter, “the contents”) on the Internet belonging to <b>KALEIDO LOGISTICS S.L.</b> to which the USER may have access. THE USER assumes responsibility for using the portal. This responsibility extends to the registration that is necessary to access certain services or contents.
          </li>
        </ol>
        <p>
          In this registry, the USER will be responsible for providing truthful and lawful information. As a result of this registration, the USER can be provided with a password for which he will be responsible, committing himself to make diligent and confidential use of it. THE USER undertakes to make appropriate use of the contents and services that <b>KALEIDO LOGISTICS S.L.</b> offers through its website, pledging not to use them for activities that may be illegal, contrary to public order, national defense or public health.
        </p>
        <p>
          In any case, <b>KALEIDO LOGISTICS S.L.</b> reserves the right to unilaterally modify, at any time and without prior notice, the structure and design of the website: modify or eliminate services or contents as well as the conditions of access and / or use of the website.
        </p>
        <p>
          In the same way <b>KALEIDO LOGISTICS S.L.</b> reserves the right to modify at any time these conditions of use, as well as any other particular conditions contained in the website <a href="https://www.kaleidologistics.com">www.kaleidologistics.com</a>
        </p>
        <ol start="4">
          <li start="4">
            <b>PERSONAL DATA PROTECTION</b>
          </li>
        </ol>
        <p><b>BASIC INFORMATION ON DATA PROTECTION</b></p>
        <table>
          <tr>
            <td><b>Responsable</b></td>
            <td>KALEIDO LOGISTICS S.L.</td>
          </tr>
          <tr>
            <td><b>Purpose</b></td>
            <td>Management of the request</td>
          </tr>
          <tr>
            <td><b>Legitimation</b></td>
            <td>Execution of a contract / provision of services</td>
          </tr>
          <tr>
            <td><b>Recipients</b></td>
            <td>Other companies or subsidiaries of the group</td>
          </tr>
          <tr>
            <td><b>Rights</b></td>
            <td>You can exercise the Access, rectification, deletion, limitation, opposition and portability of the data provided, as indicated in the additional information.</td>
          </tr>
          <tr>
            <td><b>Additional Information</b></td>
            <td>
              You can consult the additional and detailed information on Data Protection following the following link
              <br />
              <b>+Info Data Protection</b>
            </td>
          </tr>
        </table>
        <p><b>PRIVACY POLICY (II)</b></p>

        <p><b>+Info Data Protection</b></p>

        <p><b>DETAILED INFO ABOUT DATA PROTECTION</b></p>

        <table>
          <tr>
            <td><b>Responsable</b></td>
            <td>
              <p><b>Who is responsible for the processing of your data?</b></p>

              <p>Identity: KALEIDO LOGISTICS S.L.</p>

              <p>Registered Office: Calle Pontevedra 4, 3ª Planta, 36.201, Vigo (Pontevedra)</p>

              <p>Phone: 986 447 475</p>

              <p>Email: <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a></p>

              <p>Contact DPD:</p>
            </td>
          </tr>
          <tr>
            <td><b>Finalidad</b></td>
            <td>
              <p><b>For what purpose do we treat your personal data?</b></p>

              <p>In KALEIDO LOGISTICS S.L. we treat the information provided by the interested persons in order to manage the delivery of the information or the products requested.</p>

              <p>Automated data processing will be carried out in order to develop profiles with the services requested or purchases made, in order to offer promotions, offers or services for which you have shown interest.</p>

              <p><b>¿How long will we keep your data?</b></p>

              <p>The personal data provided by the user will be kept while the deletion of the same by the interested party is not requested.</p>
            </td>
          </tr>
          <tr>
            <td><b>Legitimation</b></td>
            <td>
              <p>The legal basis for the processing of your data is the execution of your request.</p>
            </td>
          </tr>
          <tr>
            <td><b>Recipients</b></td>
            <td>
              <p><b>To which recipients will your data be communicated?</b></p>
              <p>KALEIDO LOGISTICS S.L. may transfer its data to other companies or subsidiaries of the group for administrative purposes and internal management.</p>
            </td>
          </tr>
          <tr>
            <td><b>Rights</b></td>
            <td>
              <p>The user may at any time exercise the rights of Access, Rectification, Deletion, Limitation, Opposition and Portability of the data provided, as provided in the General Regulation (EU) 2016/679 on Data Protection, by writing a letter specifying what right do you wish to exercise to the above-mentioned registered office, attaching a copy of the document that identifies you, to the e-mail address <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a></p>
              <p>Likewise, the interested party may submit a claim to the Control Authority.</p>
            </td>
          </tr>
        </table>

        <p>In compliance with the provisions of the General Regulation (EU) 2016/679 on Data Protection, we inform the user that the personal data that you provide us voluntarily, by any of our means of information collection, will be incorporated into the Automated processing activities of personal data owned by <b>KALEIDO LOGISTICS S.L.</b>, in order to be able to provide our services, as well as to keep you informed about matters relating to the activity of the company and its services. The fields marked with “*” are mandatory, so the failure to fill in these fields will prevent the USER from enjoying some of the Services and information offered on the Web. The data contained in them will be treated confidentially.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> complies fully with current legislation on the protection of personal data, and confidentiality commitments specific to its activity.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> has adopted the necessary technical measures to maintain the level of security required, according to the nature of the personal data processed and the circumstances of the treatment, in order to avoid, as far as possible and always according to the state of the art, its alteration, loss, treatment or unauthorized access. In order to carry out the aforementioned management, it may be necessary to transfer the data to the data processors, collaborating companies and public administrations (which can verify the accuracy of the data).</p>

        <p>In the event that the USER provides personal data, referring to individuals other than himself, the USER must, prior to the inclusion, inform them of the contents of this clause, in accordance with the provisions of the General Regulations (UE) 2016/679 of Data Protection.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> as responsible for the Treatment Activity, guarantees the exercise of the rights of access, rectification, deletion, limitation, opposition and portability of the data provided, as provided in the General Regulation (EU) 2016/679 on Data Protection, the USER may exercise the rights at any time, writing a letter to the registered office, attaching a copy of the DNI or Passport.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> guarantees that all commercial communications directed to its customers comply with current regulations.</p>

        <p>Therefore, in compliance with Law 34/2002 on Services of the Information Society and Electronic Commerce and the General Telecommunications Act 9/2014, the USER is informed that <b>KALEIDO LOGISTICS S.L.</b> can send you electronically information about products and services of interest to which you give your consent.</p>

        <p>At any time you may revoke this authorization at the address <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a></p>
      </div>

      <div v-if="$i18n.locale == 'es'">
        <ol>
          <li>
            <b>DATOS IDENTIFICATIVOS:</b> En cumplimiento del deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio electrónico, a continuación se reflejan los siguientes datos: la empresa titular de <a href="https://www.kaleidologistics.com">kaleidologistics.com</a> es <b>KALEIDO LOGISTICS S.L.</b> con CIF B-27.716.422 y domicilio a estos efectos en Calle Pontevedra 4, 3ª Planta, 36.201, Vigo (Pontevedra) con correo electrónico de contacto: <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a>
          </li>
        </ol>
        <ol start="2">
          <li>
            <b>USUARIOS:</b> El acceso y/o uso de este portal de <b>KALEIDO LOGISTICS S.L.</b> atribuye la condición de USUARIO, que acepta, desde dicho acceso y/o uso, las Condiciones Generales de uso aquí reflejadas. Las citadas condiciones serán de aplicación independientemente de las Condiciones Generales de Contratación que en su caso resulten de obligado cumplimiento.
          </li>
          <li>
            <b>USO DEL PORTAL:</b> <a href="https://www.kaleidologistics.com">www.kaleidologistics.com</a> proporciona el acceso a multitud de informaciones, servicios, programas o datos (en adelante, “los contenidos”) en Internet pertenecientes a <b>KALEIDO LOGISTICS S.L.</b> a los que el USUARIO pueda tener acceso. EL USUARIO asume la responsabilidad de uso del portal. Dicha responsabilidad se extiende al registro que fuese necesario para acceder a determinados servicios o contenidos.
          </li>
        </ol>
        <p>
          En dicho registro el USUARIO será responsable de aportar información veraz y lícita. Como consecuencia de este registro, al USUARIO se le puede proporcionar una contraseña de la que será responsable, comprometiéndose a hacer un uso diligente y confidencial de la misma. EL USUARIO  se compromete a hacer un uso adecuado de los contenidos y servicios que <b>KALEIDO LOGISTICS S.L.</b> ofrece a través de su página Web, comprometiéndose a no utilizarlos para actividades que puedan ser ilícitas, contrarias al orden público, a la defensa nacional o a la salud pública.
        </p>
        <p>
          En todo caso, <b>KALEIDO LOGISTICS S.L.</b> se reserva el derecho de modificar unilateralmente, en cualquier momento y sin necesidad de previo aviso, la estructura y diseño del sitio Web: modificar o eliminar servicios o contenidos así como las condiciones de acceso y/o uso del sitio Web.
        </p>
        <p>
          Del mismo modo <b>KALEIDO LOGISTICS S.L.</b> se reserva el derecho a modificar en cualquier momento las presentes condiciones de uso, así como cualesquiera otras condiciones particulares contenidas en el sitio web <a href="https://www.kaleidologistics.com">www.kaleidologistics.com</a>
        </p>
        <ol start="4">
          <li start="4">
            <b>PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL</b>
          </li>
        </ol>
        <p><b>INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS</b></p>
        <table>
          <tr>
            <td><b>Responsable</b></td>
            <td>KALEIDO LOGISTICS S.L.</td>
          </tr>
          <tr>
            <td><b>Finalidad</b></td>
            <td>Gestión de la solicitud</td>
          </tr>
          <tr>
            <td><b>Legitimación</b></td>
            <td>Ejecución de un contrato / prestación de servicios</td>
          </tr>
          <tr>
            <td><b>Destinatarios</b></td>
            <td>Otras empresas o filiales del  grupo</td>
          </tr>
          <tr>
            <td><b>Derechos</b></td>
            <td>Puede ejercitar  los Acceso, rectificación, supresión, limitación, oposición y portabilidad de los datos aportados, como se indica en la información adicional.</td>
          </tr>
          <tr>
            <td><b>Información adicional</b></td>
            <td>
              Puede consultar la información adicional y detallada sobre Protección de Datos siguiendo el siguiente enlace
              <br />
              <b>+Info Protección de Datos</b>
            </td>
          </tr>
        </table>
        <p><b>POLITICA DE PRIVACIDAD (II)</b></p>

        <p><b>+Info Protección de Datos</b></p>

        <p><b>INFORMACIÓN DETALLADA PROTECCIÓN DE DATOS</b></p>

        <table>
          <tr>
            <td><b>Responsable</b></td>
            <td>
              <p><b>¿Quién es el Responsable del tratamiento de sus datos?</b></p>

              <p>Identidad: KALEIDO LOGISTICS S.L.</p>

              <p>Domicilio Social: Calle Pontevedra 4, 3ª Planta, 36.201, Vigo (Pontevedra)</p>

              <p>Teléfono: 986 447 475</p>

              <p>Email: <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a></p>

              <p>Contacto DPD:</p>
            </td>
          </tr>
          <tr>
            <td><b>Finalidad</b></td>
            <td>
              <p><b>¿Con qué finalidad tratamos sus datos?</b></p>

              <p>En KALEIDO LOGISTICS S.L. tratamos la información que nos facilitan las personas interesadas con el fin de gestionar el envió de la información o de los productos solicitados.</p>

              <p>Se realizarán tratamientos de datos automatizados con el fin de elaborar perfiles con los servicios solicitados o compras realizadas, para poder ofrecerle promociones, ofertas o servicios por los que ha mostrado interés.</p>

              <p><b>¿Por cuánto tiempo conservaremos sus datos?</b></p>

              <p>Los datos personales facilitados por el usuario se conservarán mientras no se solicite la supresión de los mismos por parte del interesado.</p>
            </td>
          </tr>
          <tr>
            <td><b>Legitimación</b></td>
            <td>
              <p>La base legal para el tratamiento de sus datos es la ejecución de su solicitud..</p>
            </td>
          </tr>
          <tr>
            <td><b>Destinatarios</b></td>
            <td>
              <p><b>¿A qué destinatarios se comunicarán sus datos?</b></p>
              <p>KALEIDO LOGISTICS S.L.  podrá ceder sus datos a otras empresas o filiales del grupo para fines administrativos y de gestión interna.</p>
            </td>
          </tr>
          <tr>
            <td><b>Derechos</b></td>
            <td>
              <p>El usuario podrá ejercer en todo momento los derechos de Acceso, Rectificación, Supresión, Limitación, Oposición y Portabilidad de los datos aportados,  según lo dispuesto en el Reglamento General (UE) 2016/679 de Protección de Datos, dirigiendo un escrito en que especifique que derecho desea ejercer al domicilio social arriba indicado, adjuntando copia del documento que lo identifique, a la dirección de correo electrónico <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a></p>
              <p>Asimismo, el interesado puede presentar una reclamación ante la Autoridad de Control.</p>
            </td>
          </tr>
        </table>

        <p>En cumplimiento de lo establecido en el Reglamento General (UE) 2016/679 de Protección de Datos, comunicamos al usuario que los datos personales que nos facilite de forma voluntaria , por cualquiera de nuestros medios de recogida de información, van a ser incorporados a las Actividades de Tratamiento automatizados de datos de carácter personal titularidad de KALEIDO LOGISTICS S.L., con el fin de poderle prestar nuestros servicios, así como para mantenerle informado sobre cuestiones relativas a la actividad de la empresa y sus servicios. Los campos marcados con “*” son de carácter obligatorio, por lo que la no cumplimentación de dichos campos impedirá al USUARIO  disfrutar de algunos de los Servicios e informaciones ofrecidas en la Web. Los datos contenidos en ellos serán tratados de forma confidencial.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> cumple íntegramente con la legislación vigente en materia de protección de datos de carácter personal, y con los compromisos de confidencialidad propios de su actividad.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> ha adoptado las medidas técnicas necesarias para mantener el nivel de seguridad requerido, según la naturaleza de los datos personales tratados y las circunstancias del tratamiento, con el objeto de evitar, en la medida de lo posible y siempre según el estado de la técnica, su alteración, pérdida, tratamiento o acceso no autorizado. Para la realización de la gestión antes mencionada puede ser necesario que se cedan los datos a encargados del tratamiento, empresas colaboradoras y administraciones públicas (las cuales pueden verificar la veracidad de los datos).</p>

        <p>En caso de que el USUARIO  facilite datos de carácter personal, referentes a personas físicas distintas a sí mismo, el USUARIO deberá, con carácter previo a la inclusión, informarles del contenido de la presente clausula, de acuerdo con lo  establecido en el Reglamento General (UE) 2016/679 de Protección de Datos.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> como responsable de la Actividad de Tratamiento, garantiza el ejercicio de los derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad de los datos aportados, según lo dispuesto en el Reglamento General (UE) 2016/679 de Protección de Datos, el USUARIO podrá ejercer en todo momento los derechos, dirigiendo un escrito al domicilio social, adjuntando copia del DNI o Pasaporte.</p>

        <p><b>KALEIDO LOGISTICS S.L.</b> garantiza que todas las comunicaciones comerciales que dirige a sus clientes cumplen la normativa vigente.</p>

        <p>Por ello, en cumplimiento de la Ley 34/2002 de Servicios de la Sociedad de la Información y de Comercio Electrónico y la Ley 9/2014 General de Telecomunicaciones, se informa al USUARIO que KALEIDO LOGISTICS S.L. podrá enviarle por medios electrónicos información acerca de productos y servicios de interés a lo que Ud. presta su consentimiento</p>

        <p>En cualquier momento podrá revocar esta autorización en la dirección <a href="mailto:kaleido@kaleidologistics.com">kaleido@kaleidologistics.com</a></p>
      </div>
      <div class="buttons">
        <button class="button is-primary" @click="$router.go(-1)">
          {{ $t('back') }}
        </button>
      </div>
    </div>
    <product-footer />
  </div>
</template>

<script>
import ProductTopBar from '@/components/product/ProductTopBar'
import ProductFooter from '../components/product/ProductFooter.vue'
export default {
  name: 'privacy-policy',
  components: { ProductTopBar, ProductFooter }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
a {
  text-decoration: none;
  color: $k-turq;
}
.page-margins{
  text-align: justify;
  margin: 0 15vw;
  padding: 4em 0;
  font-size: 1.1em;
  .page-title {
    font-family: MuseoSans-900;
    text-transform: uppercase;
    color: $k-turq;
  }
  li, p{
    margin: 2.5em 0;
  }
  b{
    font-family: MuseoSans-700;
  }
}
td b {
  margin-right: 2em;
}
.buttons {
  text-align: center;
  margin-bottom: 2em;
}
@media only screen and (max-width: 800px) {
  .page-margins{
    margin: 0 5vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PagePrivacyPolicy.vue